import { DataBean } from "../../DataBean";


export class PilaDataForRetroactive extends DataBean {

    public async createPilaDataForRetroactive(idSocialSecuritySpreadSheet: any, percent: any, minSalaryValue: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.SocialSecuritySpreadSheet_createPilaDataForRetroactive_Number_Number_Number_Number", [idSocialSecuritySpreadSheet, percent, minSalaryValue, idEmployee]);
    }

}